var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"collar-leash-select-row mx-auto"},_vm._l((_vm.groups),function(group){return _c('CollarLeashGroup',{key:group.id,attrs:{"group":group,"product-style-code":_vm.productStyleCode},on:{"submit":_vm.redirectToStyle}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }